import { render, staticRenderFns } from "./CTReadingIncorrect.AU.5.vue?vue&type=template&id=7532e3dc&scoped=true"
import script from "./CTReadingIncorrect.AU.5.vue?vue&type=script&lang=js"
export * from "./CTReadingIncorrect.AU.5.vue?vue&type=script&lang=js"
import style0 from "./CTReadingIncorrect.AU.5.vue?vue&type=style&index=0&id=7532e3dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7532e3dc",
  null
  
)

export default component.exports